module.exports = __webpack_public_path__ + "img/GPG Sweethearts.d1af637e.png";